import React from 'react';
import Menu from './Menu.js';
import Foot from './Foot.js';
import StepItem from './StepItem.js';
import rackPic from '../Images/rack.jpg';
import plantPic from '../Images/plant.jpg';
import '../Styles/Info.css';

const Info = () => {
	return (
		<div classname="Info-page">
			<header>
				<Menu id="Menu" className="row-container"/>	
			</header>
			<main>
				<div id="Info" className="gutter">
					<h1 className="center-text">
						How it Works
					</h1>
					<section className="steps-container">	
						<StepItem
						    stepNum={1}
						    title="Securing items"
						>
							<ul className="comment-me">
								<li><span className="underline-savanna">Comment me</span> on the instagram post of the item you would like to purchase</li>
								<li>If an item says <bold className="bold-josefin"> SOLD</bold> it is no longer available </li>
								<li>If someone has commented before you, you can still comment in case the order falls through so that you are next in line </li>
								<li>For bidding items, bid in increments of R10 (bidding lasts 24 hours)</li>
							</ul>
						</StepItem>

						<div className="step-display-container">
							<img 
								alt="" 
								src={rackPic} 
								className="step-display"
							/>
						</div>
						<div className="step-display-container">
							<img 
								alt="" 
								src={plantPic} 
								className="step-display"
							/> 
						</div>

						<StepItem
						    stepNum={2}
						    title="Pick a Courier"
						> 
							<p> We can get your parcel to you in the way that's most convenient for you</p>
							<ul>
								<li> <span className="underline-savanna"> Paxi </span> : Pep-to-pep delivery system</li>
								<li> <span className="underline-savanna"> Aramex </span> : Pic'n Pay, Freshtop and Checkers to your location </li>
								<li> <span className="underline-savanna"> Collection </span> : You can pick up your parcel and pay <bold className="bold-josefin"> cash </bold> at the following address: <br/> <span className="bold-josefin"> 5 Tarry Road Alroad South Alberton </span> </li>
							</ul>

						</StepItem> 

						<StepItem 
							stepNum={3} 
							optional={true}
							title="Build-a-bag"
						> 
							<p> You are more than welcome to <span className="underline-savanna"> build a bag</span></p>
							<p> If you want to purchase more than one item, then I can keep the bag until you want it to be sent out. Advantages of this option is that you save your  money and the environment !!</p>
						</StepItem>
						<StepItem
							stepNum={4}
							title="Collect your order"
						>
					   	    <p> And don't forget to tag us in your very own Thrift-Savanna aparrel :)</p>
							<p> Click <a href="/terms_and_conditions">here</a> to our Terms and Conditions </p>
						</StepItem>
					
					</section>
				</div>
			</main>
			<footer className="centered">
				<Foot/>
			</footer>
		</div>
	)
}

export default Info;